import React, { useEffect, useRef, useState } from "react";
import { PRIMARY_COLOR } from "../../assets/style/colors";
import {
  call,
  Logo,
  password,
  reminder,
  reminder_1,
  pass_un,
  person,
  bg,
  back_icon,
  countryArr,
} from "../../assets/img";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { URLS } from "../../Services/Constant";
import { post } from "../../Services/ApiHandler";
import countryData from "../../Services/CountryData.json";
import { Toast } from "../../Component/Toast";
import { MaskIcon } from "../MaskIcon";

const Register = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [showOtp, setShowOtp] = useState(false);
  const [mobile, setMobile] = useState("");
  const [errors, setErrors] = useState({ name: "", mobile: "" });
  const [name, setName] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const otpInputs = useRef([]);
  const [timer, setTimer] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [country, setCountry] = useState("IN");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(
    countryData.find((c) => c.iso === "IN") || countryData[0],
  );

  const maxLength = selectedCountry?.maxLength;
  // // console.log("maxLength", maxLength);

  const validatePhone = (value, countryCode = "IN") => {
    const phoneNumber = parsePhoneNumberFromString(value, countryCode);
    return phoneNumber ? phoneNumber.isValid() : false;
  };

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/[^\d]/g, "");
    if (value.length <= maxLength) {
      setMobile(value);
      setErrors((prev) => ({ ...prev, mobile: "" }));
    }
  };

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setCountryCode(country.code);
    setCountry(country.iso);
    setMobile(mobile.slice(0, country.maxLength));
    setErrors((prev) => ({ ...prev, mobile: "" }));
    setDropdownOpen(false);
  };

  useEffect(() => {
    const nameValid = name.trim().length >= 3;
    const mobileValid =
      validatePhone(mobile, country) && mobile.length >= (maxLength || 10);
    setIsFormValid(nameValid && mobileValid);
  }, [name, mobile, country, maxLength]);

  // // console.log("isFormValid", isFormValid);

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const location = useLocation();
  const [refCode, setRefCode] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get("ref");
    if (ref) {
      setRefCode(ref);
      // // console.log("Referral Code:", ref);
    }
  }, [location.search]);

  const handleSendOtp = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!name || name.trim().length < 3) {
      newErrors.name = "Name must be at least 3 characters";
    }

    if (!validatePhone(mobile, country)) {
      newErrors.mobile = "Enter a valid phone number ...";
    } else if (mobile.length < (maxLength || 10)) {
      newErrors.mobile = `Phone number must be at least ${maxLength || 10} digits`;
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const cleanMobile = mobile.replace(countryCode, "").replace(/[^\d]/g, "");

    const formdata = {
      mobile: cleanMobile,
      name: name.trim(),
      country_code: countryCode,
    };

    // // console.log("Form Data:", formdata);

    try {
      setLoading(true);
      const res = await post(URLS.REGISTER, formdata);
      // // console.log("Register Response:", res);

      if (res?.status === "success") {
        Toast("OTP sent successfully!");
        setShowOtp(true);
        setTimer(60);
        setOtp(["", "", "", ""]);
        setErrors({});
        setTimeout(() => {
          otpInputs.current?.[0]?.focus();
        }, 300);
        // alert(`OTP: ${res?.otp}`);
      }
    } catch (err) {
      // // console.log("Error during register:", err);
      Toast("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setOtp(["", "", "", ""]);
    setTimer(60);
    const cleanMobile = mobile.replace(countryCode, "").replace(/[^\d]/g, "");

    const formdata = {
      mobile: cleanMobile,
      name: name.trim(),
      country_code: countryCode,
    };

    // // console.log("Form Data:", formdata);

    try {
      const res = await post(URLS.REGISTER, formdata);
      // // console.log("Register resent Response:", res);
      if (res?.status === "success") {
        Toast("OTP resent successfully!");
        // alert(`OTP: ${res?.otp}`);
      }
    } catch (err) {
      // // console.log('err', err);
    }
  };

  const handleContinue = async () => {
    if (otp.join("").length !== 4) {
      Toast("Please enter valid 4-digit OTP");
      return;
    }

    const cleanMobile = mobile.replace(countryCode, "").replace(/[^\d]/g, "");

    const formdata = {
      otp: `${otp[0]}${otp[1]}${otp[2]}${otp[3]}`,
      mobile: cleanMobile,
      country_code: countryCode,
      name: name.trim(),
      referral: refCode || "",
    };
    // // console.log("formdata", formdata);

    try {
      setLoading1(true);
      const res = await post(URLS.VERIFYOTP, formdata);
      // // console.log("Register otp Response:", res?.user_id);

      if (res?.status === "success") {
        setLoading1(false);
        Toast("OTP Verified Successfully!");
        navigate("/create-password", {
          state: { id: res?.user_id, type: "register" },
        });
      }
    } catch (err) {
      // // console.log("err", err);
      setLoading1(false);
    } finally {
      setLoading1(false);
    }
  };

  const handleChange = (value, index) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 3) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...otp];
      if (newOtp[index]) {
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        document.getElementById(`otp-${index - 1}`).focus();
        const prevOtp = [...otp];
        prevOtp[index - 1] = "";
        setOtp(prevOtp);
      }
    }
  };

 return (
  <div style={{ backgroundColor: '#f0ede6', minHeight: '100vh' }}>
    
    {/* HEADER */}
    <div style={{
      backgroundColor: PRIMARY_COLOR,
      padding: '15px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'sticky',
      top: 0,
      zIndex: 10,
      userSelect: 'none',       
     WebkitUserSelect: 'none'
    }}>
      <span onClick={() => navigate(-1)} style={{ cursor: 'pointer' }}>
        <ArrowBackOutlinedIcon style={{ color: '#fff', fontSize: 22 }} />
      </span>
      <h2 style={{ color: '#fff', fontSize: 18, margin: 0 }} className="f4">
        Register
      </h2>
      <div style={{ width: 22 }} />
    </div>

    {/* FORM */}
    <div style={{ padding: '20px 20px 40px', maxWidth: 480, margin: '0 auto' }}>
      <form>

        {/* NAME */}
        <div className="form-group text-start mt-2">
          <label style={{ color: '#00416CCC' }} className="form-label mb-0 f3">
            Name
          </label>
          <div className="login-input mt-1" style={{ backgroundColor: '#F0EDE6' }}>
            <input
              value={name}
              className="placholdercolorchanges f2"
              onChange={(e) => {
                setName(e.target.value);
                if (errors.name) setErrors({ ...errors, name: '' });
              }}
              style={{ height: 50, backgroundColor: '#F0EDE6' }}
              placeholder="Enter your name"
              required
            />
            <MaskIcon src={person} style={{ width: 18, height: 18, marginRight: 12 }} alt="person" />
          </div>
          {errors.name && <p className="err">{errors.name}</p>}
        </div>

        {/* MOBILE */}
        <div style={{ marginTop: 25 }} className="form-group text-start">
          <label style={{ color: '#00416CCC' }} className="form-label f3 mb-0">
            Mobile Number
          </label>
          <div
            className="login-input mt-1"
            style={{
              height: 50,
              background: '#F0EDE6',
              display: 'flex',
              alignItems: 'center',
              borderRadius: 8,
              position: 'relative',
            }}
          >
            <button
              type="button"
              onClick={() => setDropdownOpen(!dropdownOpen)}
              style={{
                backgroundColor: '#6E6E6E',
                border: `1px solid ${PRIMARY_COLOR}`,
                color: '#ffffff',
                fontSize: 16,
                height: 50,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                borderRadius: '8px 0 0 8px',
                padding: '0px 10px',
                fontWeight: 600,
                gap: 6,
              }}
            >
              <img src={countryArr} style={{ width: 14, height: 8 }} alt="" />
              {selectedCountry.code}
            </button>

            <input
              type="number"
              placeholder="Mobile Number"
              value={mobile}
              onKeyDown={(e) => {
                if (['-', '+', '.', 'e', 'E'].includes(e.key)) e.preventDefault();
              }}
              className="placholdercolorchanges f2"
              onChange={handleMobileChange}
              style={{
                flex: 1,
                border: 'none',
                outline: 'none',
                backgroundColor: 'transparent',
                fontSize: 16,
                color: '#1B1B1B',
                padding: '0 10px',
                height: 50,
              }}
            />

            <MaskIcon src={call} alt="call" style={{ marginRight: 12, width: 17 }} />

            {dropdownOpen && (
              <div style={{
                position: 'absolute',
                top: 52,
                left: 0,
                right: 0,
                backgroundColor: '#ffffff',
                border: '1px solid rgb(0 71 67 / 40%)',
                borderRadius: 8,
                maxHeight: 200,
                overflowY: 'auto',
                zIndex: 1000,
              }}>
                {countryData.map((c) => (
                  <div
                    key={c.iso}
                    onClick={() => handleCountrySelect(c)}
                    style={{
                      padding: '10px',
                      cursor: 'pointer',
                      borderBottom: '1px solid rgb(0 71 67 / 40%)',
                      backgroundColor: selectedCountry.iso === c.iso ? '#ffffff' : '#F0EDE6',
                    }}
                  >
                    {c.name}
                  </div>
                ))}
              </div>
            )}
          </div>
          {errors.mobile && <p className="err">{errors.mobile}</p>}
        </div>

        {/* REFERRAL */}
        <div style={{ marginTop: 25, marginBottom: 25 }} className="form-group text-start">
          <label style={{ color: '#00416CCC' }} className="form-label mb-0 f3">
            Referral Code
          </label>
          <div className="login-input mt-1">
            <input
              type="tel"
              className="placholdercolorchanges f2"
              value={refCode}
              style={{
                height: 50,
                backgroundColor: '#F0EDE6',
                textAlign: refCode ? 'left' : 'center',
              }}
              placeholder="--"
              disabled
            />
          </div>
        </div>

        {/* SEND OTP BUTTON */}
        {!showOtp && (
          <button
            disabled={!isFormValid || showOtp}
            type="button"
            style={{
              height: 50,
              backgroundColor: isFormValid ? PRIMARY_COLOR : '#7ea1b8cc',
              cursor: isFormValid ? 'pointer' : 'not-allowed',
              color: 'white',
              width: '100%',
              border: 'none',
              borderRadius: 40,
              fontSize: 16,
            }}
            className="f3"
            onClick={handleSendOtp}
          >
            {loading ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
                style={{ color: 'white', padding: 8 }}
              />
            ) : 'Send OTP'}
          </button>
        )}

        {/* OTP SECTION */}
        {showOtp && (
          <>
            <p className="my-2 f3 primary" style={{ fontSize: 16 }}>
              Enter the OTP
            </p>
            <div className="otp-container">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                  type="tel"
                  maxLength="1"
                  ref={(ref) => (otpInputs.current[index] = ref)}
                  value={digit}
                  onChange={(e) => handleChange(e.target.value, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  className="otp-input"
                />
              ))}
            </div>
            <p className="mt-2 f2 text-end" style={{ fontSize: 14, color: PRIMARY_COLOR }}>
              {timer > 0 ? (
                `Resend OTP in ${timer}s`
              ) : (
                <span style={{ color: PRIMARY_COLOR, cursor: 'pointer' }} onClick={handleResend}>
                  Resend OTP
                </span>
              )}
            </p>
            <button
              disabled={otp.join('').length !== 4}
              style={{
                height: 50,
                backgroundColor: otp.join('').length !== 4 ? '#7ea1b8cc' : PRIMARY_COLOR,
                color: 'white',
                width: '100%',
                border: 'none',
                borderRadius: 40,
                fontSize: 16,
              }}
              type="button"
              onClick={handleContinue}
              className="f3 mt-3"
            >
              {loading1 ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: 'white', padding: 8 }}
                />
              ) : 'Continue'}
            </button>
          </>
        )}

      </form>
    </div>
  </div>
);
};

export default Register;
